export default __webpack_public_path__ + "91ca1c9b37922197f6ca30e320dc9904.png";